import React, { useEffect, useState, useCallback } from "react";
import { Card, Badge, Table } from "react-bootstrap";
import axiosInstance from "../services/axiosInterceptor";
import { getUserId } from "../services/authorize";
import { useLoading } from "../contexts/LoadingContext";
import { useLanguage } from "../contexts/LanguageContext";
import th   from "../locales/islamic/th";
import jawi from "../locales/islamic/jawi";

export default function IslamicAdvisorStudents() {
  const { setLoading } = useLoading();
  const { lang } = useLanguage();
  const t = lang === 'th' ? th : jawi;

  const [yearId, setYearId] = useState(() => localStorage.getItem("yearId") || null);
  const [yearList, setYearList] = useState([]);
  const [room, setRoom] = useState(null);
  const [students, setStudents] = useState([]);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`)
      .then(res => {
        const list = res.data;
        setYearList(list);
        let id = localStorage.getItem("yearId");
        if (!id && list.length > 0) { id = list[0].year_id; localStorage.setItem("yearId", id); }
        setYearId(id);
      })
      .catch(() => {});
  }, []);

  const fetchData = useCallback((yr_id) => {
    if (!yr_id) return;
    const t_id = getUserId();
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/islamic-advisor/myRoom/${t_id}/${yr_id}`)
      .then(res => {
        setRoom(res.data);
        return axiosInstance.get(`${process.env.REACT_APP_API}/islamic-advisor/students/${res.data.ir_id}`);
      })
      .then(res => setStudents(res.data))
      .catch(() => { setRoom(null); setStudents([]); })
      .finally(() => setLoading(false));
  }, [setLoading]);

  useEffect(() => { fetchData(yearId); }, [yearId, fetchData]);

  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h4 className="main-title mb-0">{t.advisorStudents.pageTitle}</h4>
          {room && (
            <p className="text-secondary mb-0 small">
              {t.common.classNo(room.ic_class, room.ir_no)}&nbsp;&nbsp;
              <Badge bg="info">{room.is_programCode}</Badge>
              &nbsp;
              <Badge bg={room.ir_gender === 'm' ? 'primary' : 'danger'}>{room.ir_gender === 'm' ? t.common.male : t.common.female}</Badge>
            </p>
          )}
        </div>
        <select
          className="form-select w-auto"
          value={yearId || ""}
          onChange={e => { localStorage.setItem("yearId", e.target.value); setYearId(e.target.value); }}
        >
          {yearList.map(y => (
            <option key={y.year_id} value={y.year_id}>{t.common.studyYear(y.year_year)}</option>
          ))}
        </select>
      </div>

      {!room ? (
        <Card className="card-one">
          <Card.Body className="text-center text-secondary py-5">
            <i className="ri-information-line fs-3 d-block mb-2"></i>
            {t.advisorStudents.noRoom}
          </Card.Body>
        </Card>
      ) : (
        <Card className="card-one">
          <Card.Header className="d-flex align-items-center gap-2">
            <span className="fw-semibold">{t.advisorStudents.totalStudents}</span>
            <Badge bg="secondary">{t.common.personCount(room.student_count)}</Badge>
          </Card.Header>
          <Card.Body className="p-0">
            {students.length === 0 ? (
              <p className="text-center text-secondary py-4">{t.advisorStudents.noStudents}</p>
            ) : (
              <Table hover responsive className="mb-0">
                <thead className="table-secondary">
                  <tr>
                    <th style={{ width: 40 }}>#</th>
                    <th>{t.advisorStudents.colNo}</th>
                    <th>{t.advisorStudents.colName}</th>
                    <th>{t.advisorStudents.colArabicName}</th>
                    <th className="text-center">{t.advisorStudents.colGender}</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((s, idx) => (
                    <tr key={s.is_study_id}>
                      <td className="text-secondary align-middle">{idx + 1}</td>
                      <td className="align-middle">{s.st_idnumber}</td>
                      <td className="align-middle">{s.st_name}</td>
                      <td className="align-middle arabic-text">{s.st_arabicname || <span className="text-muted">-</span>}</td>
                      <td className="text-center align-middle">
                        <Badge bg={s.st_gen === 'm' ? 'primary' : 'danger'} className="small">
                          {s.st_gen === 'm' ? t.common.male : t.common.female}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      )}
    </React.Fragment>
  );
}
